import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import LoginRoute from '~/features/auth/routes/Login.route';

const loginSearchProps = z.object({
    redirect: z.string().optional().catch('/'),
});

export const Route = createFileRoute('/_auth/login/')({
    beforeLoad: () => {
        return {
            meta: [
                {
                    content: 'noindex',
                    name: 'robots',
                },
            ],
        };
    },
    component: () => <LoginRoute />,
    validateSearch: loginSearchProps,
});
